module.exports = __webpack_public_path__ + "static/media/bill-settlement.d031c5f6.svg";